import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  width: ${({ size }) => size + "px" || "40px"};
  height: ${({ size }) => size + "px" || "40px"};
  border: 4px solid rgba(0, 0, 0, 0.1); /* Background border */
  border-top: 4px solid ${({ color }) => color || "#052d43"}; /* Foreground color */
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
margin: auto;
    align-self: center;
`;

const CustomCircularProgress = ({ size = "40px", color = "#052d43", padding = "0px" }) => {
  return <Spinner size={size} color={color} padding={padding} />;
};

export default CustomCircularProgress;
